import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';
// let Draggable = require('react-draggable'); //https://github.com/mzabriskie/react-draggable/pull/217/files
let Draggable = require('../../../global/lib/react-draggable/');
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import VideoPlayer from "../../../global/components/helpers/VideoPlayer.js.jsx";
import PDFViewer from '../../../global/components/helpers/PDFViewer.js.jsx';

// import utils
import graphUtils from "../../../global/utils/graphUtils";
import richContentUtils from '../../../global/utils/richContentUtils';
import videoUtils from "../../../global/utils/videoUtils.js";
import MetricSelectorSearchItem from '../../metric/components/MetricSelectorSearchItem.js.jsx';

const simUrl = window.simUrl;

class GraphNode extends Base {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "info"
    }
    this._bind(
      '_onDragStart'
      , '_onDragEnd'
      , '_onDrag'
      , '_handleDoubleClick'
      , '_onMouseDown'
      , '_onMouseUp'
    )
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   return (
  //     nextProps.selected !== this.props.selected
  //     || nextProps.scale !== this.props.scale
  //     || !_.isEqual(nextProps.scene, this.props.scene)
  //     || nextProps.node !== this.props.node
  //     || nextState.activeTab !== this.state.activeTab
  //     || nextProps.node && nextProps.node._scene !== this.props.node._scene
  //   ); //TODO: more checks here for title or scene changes
  // }

  _onDragStart(e, ui) {
    // console.log("drag start", ui.x, ui.y)
    // not used for anything currently
    // this.props.onDragStart(this.props.node, ui.x, ui.y);
  }

  _onDragEnd(e, ui) {
    // console.log("drag stop", ui.x, ui.y)
    // pass up to parents to save
    this.props.onDragEnd(this.props.node, ui.x, ui.y);
  }

  _onDrag(e, ui) {
    // console.log("handle drag", ui.x, ui.y)
    // for drawing transitions
    this.props.onDrag(this.props.node, ui.x, ui.y);
  }


  _handleDoubleClick(e) {
    // prevent graph.doubleClick (to create new node) from firing
    e.preventDefault();
    e.stopPropagation();

    // then "select" the node
    if(this.props.onSelect) {
      this.props.onSelect(this.props.node);
    }
  }

  _onMouseDown(e) {
    // to be able to pan/zoom, we need to be able to click and drag
    // however clicking on a NODE has a different action, so we need to override it on those mouse down events
    // this only exists to prevent mouseDown on a node from triggering mouseDown on the graph
    e.preventDefault();
    e.stopPropagation();
  }

  _onMouseUp(e) {
    // catch for mouse up on a node.
    // we will use this to tell if a new transition needs to be created
    this.props.onMouseUp(this.props.node)
    e.preventDefault();
    e.stopPropagation();
  }

	render() {
    const { node, scale, scene, selected, selectedScene, metrics } = this.props;
    // console.log("rendering a node");
    // console.log(metrics)
    let nodeWrapperClass = classNames(
      'node-wrapper default'
      , {
        'selected': selected
        , 'start': node.start
        , 'exit': node.exit
        , 'question': node.question
        , 'correct': node.answer && node.correct == 'correct'
        , 'incorrect': node.answer && node.correct == 'incorrect'
        , 'survey': node.answer && node.correct == 'survey'
        , 'topic-change': node.topicChange
        , 'empty': !node._scene
      }
    )
    let iconsClass = classNames(
      '-icons'
      , {
        'question': node.question
        , 'correct': node.answer && node.correct == 'correct'
        , 'incorrect': node.answer && node.correct == 'incorrect'
        , 'start': node.start
        , 'exit': node.exit
      }
    )
    let infoTab = classNames(
      "yt-btn x-small dark"
      , { "-active": this.state.activeTab === 'info' }
    )
    let sceneTab = classNames(
      "yt-btn x-small dark"
      , { "-active": this.state.activeTab === 'scene' }
    )
    return (
      <div
        className="graph_node_wrapper"
        onDoubleClick={this._handleDoubleClick}
        onMouseDown={this._onMouseDown}
        onMouseUp={this._onMouseUp}
      >
        <Draggable
          bounds={'#graph_id'}
          defaultPosition={{x:node.authoring.x,y:node.authoring.y}}
          handle=".node-header"
          onStart={(e, ui) => this._onDragStart(e, ui)}
          onStop={(e, ui) => this._onDragEnd(e, ui)}
          onDrag={(e, ui) => this._onDrag(e, ui)}
          scale={scale}
        >
          <div className='graph_node' style={selected ? {zIndex: 100000000 } : null}>
            <div className={nodeWrapperClass}>
              { selected ?
                <div className="selected-wrapper"></div>
                :
                null
              }
              <div className="node-header">
                { node.start ?
                  <div>
                    <ReactTooltip
                      aria-haspopup='true'
                      className="yt-tooltip"
                      id={`start-node_${node._id}`}
                      place="top"
                      type="dark"
                      >
                      <h2 style={{whiteSpace: 'nowrap'}}>START HERE</h2>
                    </ReactTooltip>
                    <div className="start-icon" data-tip data-for={`start-node_${node._id}`}>
                      <i className="fas fa-star"/>
                    </div>
                  </div>
                  :
                  null
                }
                <div className={iconsClass}>
                  { node.toc ?
                    <div>
                      <ReactTooltip
                        aria-haspopup='true'
                        className="yt-tooltip"
                        id={`toc-node_${node._id}`}
                        place="top"
                        type="dark"
                        >
                        <p style={{whiteSpace: 'nowrap'}}>Table of Contents</p>
                      </ReactTooltip>
                      <div className="-icon -toc" data-tip data-for={`toc-node_${node._id}`}>
                        <i className="fas fa-list" />
                      </div>
                    </div>
                    :
                    null
                  }
                  { node._scene && scene.videoPath ?
                    <div>
                      <ReactTooltip
                        aria-haspopup='true'
                        className="yt-tooltip"
                        id={`has-video_${node._id}`}
                        place="top"
                        type="dark"
                        >
                        <p style={{whiteSpace: 'nowrap'}}>Has video</p>
                      </ReactTooltip>
                      <div className="-icon -has-video" data-tip data-for={`has-video_${node._id}`}>
                        <i className="fas fa-video"/>
                      </div>
                    </div>
                    :
                    null
                  }
                  { node._scene && !scene.videoPath ?
                    <div>
                      <ReactTooltip
                        aria-haspopup='true'
                        className="yt-tooltip"
                        id={`no-video_${node._id}`}
                        place="top"
                        type="dark"
                        >
                        <p style={{whiteSpace: 'nowrap'}}>No video</p>
                      </ReactTooltip>
                      <div className="-icon -no-video" data-tip data-for={`no-video_${node._id}`}>
                        <i className="fal fa-video-slash"/>
                      </div>
                    </div>
                    :
                    null
                  }
                  {scene && scene.transparentOverlay ?
                    <div>
                      <ReactTooltip
                        aria-haspopup='true'
                        className="yt-tooltip"
                        id={`transparent-overlay_${node._id}`}
                        place="top"
                        type="dark"
                        >
                        <p style={{whiteSpace: 'nowrap'}}>Transparent overlay</p>
                      </ReactTooltip>
                      <div className="-icon -transparent-overlay" data-tip data-for={`transparent-overlay_${node._id}`}>
                        <i className="fas fa-photo-video"/>
                      </div>
                    </div>
                    :
                    null
                  }
                  { node.answer && node.correct == 'correct' ?
                    <div>
                      <ReactTooltip
                        aria-haspopup='true'
                        className="yt-tooltip"
                        id={`correct_${node._id}`}
                        place="top"
                        type="dark"
                        >
                        <p style={{whiteSpace: 'nowrap'}}>Correct answer</p>
                      </ReactTooltip>
                      <div className="-icon -correct" data-tip data-for={`correct_${node._id}`}>
                        <i className="far fa-thumbs-up"/>
                      </div>
                    </div>
                    :
                    null
                  }
                  { node.answer && node.correct == 'incorrect' ?
                    <div>
                      <ReactTooltip
                        aria-haspopup='true'
                        className="yt-tooltip"
                        id={`incorrect_${node._id}`}
                        place="top"
                        type="dark"
                        >
                        <p style={{whiteSpace: 'nowrap'}}>Incorrect answer</p>
                      </ReactTooltip>
                      <div className="-icon -correct" data-tip data-for={`incorrect_${node._id}`}>
                        <i className="far fa-thumbs-down"/>
                      </div>
                    </div>
                    :
                    null
                  }
                  { node.question ?
                    <div>
                      <ReactTooltip
                        aria-haspopup='true'
                        className="yt-tooltip"
                        id={`question_${node._id}`}
                        place="top"
                        type="dark"
                        >
                        <p style={{whiteSpace: 'nowrap'}}>Question node</p>
                      </ReactTooltip>
                      <div className="-icon -question" data-tip data-for={`question_${node._id}`}>
                        <i className="fas fa-question"/>
                      </div>
                    </div>
                    :
                    null
                  }
                  { metrics && metrics.length > 0 ?
                    <div>
                      <ReactTooltip
                        aria-haspopup='true'
                        className="yt-tooltip"
                        id={`metric_${node._id}`}
                        place="top"
                        type="dark"
                      >
                        <p style={{whiteSpace: 'pre-wrap', minWidth: '300px'}}>{metrics.length} Metrics:</p>
                        <ul style={{whiteSpace: 'pre-wrap', minWidth: '260px'}}>
                          { metrics.map((metric, i) => {
                            if(metric && metric._id) {
                              return (
                                <li key={metric._id + '__' + i}>
                                  {metric.order} - {metric.title}
                                </li>
                              )
                            } else {
                              return null
                            }                              
                          })}
                        </ul>
                      </ReactTooltip>
                      <div className="-icon -metric" data-tip data-for={`metric_${node._id}`}>
                        <i className="far fa-chart-bar"/>
                      </div>
                    </div>
                    :
                    null
                  }
                  { node.checkpoint ?
                    <div>
                      <ReactTooltip
                        aria-haspopup='true'
                        className="yt-tooltip"
                        id={`checkpoint_${node._id}`}
                        place="top"
                        type="dark"
                        >
                        <p style={{whiteSpace: 'nowrap'}}>Checkpoint node</p>
                      </ReactTooltip>
                      <div className="-icon -checkpoint" data-tip data-for={`checkpoint_${node._id}`}>
                        <i className="fas fa-check"/>
                      </div>
                    </div>
                    :
                    null
                  }

                </div>
                { node.exit ?
                  <div>
                    <ReactTooltip
                      aria-haspopup='true'
                      className="yt-tooltip"
                      id={`exit_${node._id}`}
                      place="top"
                      type="dark"
                      >
                      <p style={{whiteSpace: 'nowrap'}}>Exit node</p>
                    </ReactTooltip>
                    <div className="exit-icon" data-tip data-for={`exit_${node._id}`}>
                      <i className="fas fa-sign-out"/>
                    </div>
                  </div>
                  :
                  null
                }
                <div className="author-code">{node.authoring.code}</div>
                <span></span>
              </div>
              <ReactTooltip
                aria-haspopup='true'
                className="yt-tooltip"
                id={`new_transition_${node._id}`}
                place="bottom"
                type="light"
                >
                <p style={{whiteSpace: 'nowrap'}}>New transition</p>
              </ReactTooltip>
              <div className="node-bottom" data-tip data-for={`new_transition_${node._id}`} onMouseDown={(e) => this.props.onStartTransition(node)}>
                <span></span>
              </div>
            </div>
            { selected ?
              <div className="node-details" style={{transform: `scale(${1/scale})`}}>
                <div className="-controls">
                  <ReactTooltip
                    aria-haspopup='true'
                    className="yt-tooltip"
                    id={`node-info_${node._id}`}
                    place="top"
                    type="light"
                    >
                      <p>Node info</p>
                  </ReactTooltip>
                  <button className={infoTab} data-tip data-for={`node-info_${node._id}`} onClick={()=> this.setState({activeTab: 'info'})}><i className="fas fa-info"/></button>
                  <ReactTooltip
                    aria-haspopup='true'
                    className="yt-tooltip"
                    id={`scene-preview_${node._id}`}
                    place="top"
                    type="light"
                    >
                      <p>Scene preview</p>
                  </ReactTooltip>
                  <button className={sceneTab} data-tip data-for={`scene-preview_${node._id}`} onClick={()=> this.setState({activeTab: 'scene'})}><i className="fas fa-video"/></button>
                  <ReactTooltip
                    aria-haspopup='true'
                    className="yt-tooltip"
                    id={`delete-node_${node._id}`}
                    place="top"
                    type="error"
                    >
                      <p style={{whiteSpace: 'nowrap'}}>Delete Node</p>
                  </ReactTooltip>
                  <button className="yt-btn x-small dark u-pullRight" data-tip data-for={`delete-node_${node._id}`} onClick={()=> this.props.handleOpenModal('deleteNode')}><i className="fas fa-trash"/></button>
                </div>
                <div className="-content">
                  { this.state.activeTab === "scene" ?
                    <div className="-scene-preview">
                      <div className="yt-row space-between">
                        <p><strong>Scene preview:</strong></p>
                        { node._scene &&  selectedScene ? 
                          <Link to={`/admin/authoring/scenes/${selectedScene._id}`} target="_blank">View full scene <i className="fas fa-external-link"/></Link>
                          :
                          null
                        }
                      </div>
                      { node._scene && selectedScene ?
                        <div className="-scene-info">
                          { selectedScene.videoPath ?
                            <VideoPlayer
                              isAutoPlay={false}
                              onComplete={()=> console.log('complete')}
                              playerId={selectedScene._id}
                              playlist={videoUtils.returnPlaylist(selectedScene.videoPath, selectedScene.posterPath, selectedScene.tracks) }
                            />
                            :
                            selectedScene.pdfPath ?
                            <div className="-media-preview">
                              <PDFViewer
                                file={selectedScene.pdfPath}
                              />
                            </div>
                            :
                            <p><em>Preview not available</em></p>
                          }
                          <h3>{selectedScene.title}</h3>
                            <button className="yt-btn small block  info" onClick={() => this.props.handleOpenModal('editScene')}>Edit this scene</button>
                            <button className="yt-btn small block link danger" onClick={() => this.props.handleOpenModal('unlinkScene')}>Unlink scene</button>
                        </div>
                        :
                        <div className="-no-scene">
                          <p><em>No scene yet:</em></p>
                          <button className="yt-btn small block info" onClick={() => this.props.handleOpenModal('newScene')}>New scene</button>
                          {/**<button className="yt-btn small block link info">Link from library</button>*/}
                        </div>
                      }
                    </div>
                    :
                    <div className="-node-info">
                      <div className="yt-row space-between">
                        <p><strong>Node info at a glance</strong></p>
                        <a href={`${simUrl}/preview/content-modules/${this.props.selectedContentModuleId}/nodes/${node._id}`} target="_blank">Preview node <i className="fas fa-external-link"/></a>
                      </div>
                      <hr/>
                      <p><strong>Authoring Code:</strong></p>
                      <p> {node.authoring.code} </p>

                      { node.orderWeight ?
                        <div>
                          <hr/>
                          <p><strong>Order weight:</strong></p>
                          <p>This node's order weight is set to <strong>#{node.orderWeight}</strong> </p>
                          <small><em>Follow ups are sorted low-to-high by order weight.</em></small>
                        </div>
                        :
                        null
                      }
                      <hr/>
                      { node.toc ?
                        <div className="yt-row">
                          <div className="-icon"><i className="fas fa-list"/> </div>
                          <div className="yt-col">
                            Appears in table of contents
                          </div>
                        </div>
                        :
                        null
                      }
                      { metrics && metrics.length > 0 ?
                        <div className="yt-row">
                          <div className="-icon"><i className="far fa-chart-bar"/> </div>
                          <div className="yt-col">
                            <strong>{metrics.length} tracking metrics: </strong>  
                            <ul style={{padding: "0 15px"}}>
                              {metrics.map((metric, i) => {
                                if(metric && metric._id) {
                                  return (
                                    <li key={metric._id + '__' + i}>
                                      <a 
                                        href={`${window.authoringUrl}/metrics/${metric._id}`}
                                        target="_blank"
                                      >
                                        {metric.order} - {metric.title}
                                      </a>
                                    </li>
                                  )
                                } else {
                                  return null
                                }
                              })}
                            </ul>
                          </div>
                        </div>
                        :
                        null
                      }
                      { node.question ?
                        <div className="yt-row">
                          <div className="-icon"><i className="fas fa-question"/> </div>
                          <div className="yt-col">
                            Question node <em>(see scene)</em>
                          </div>
                        </div>
                        :
                        null
                      }
                      { node.answer && node.correct == 'correct' ?
                        <div className="yt-row">
                          <div className="-icon"><i className="far fa-thumbs-up"/> </div>
                          <div className="yt-col">
                            This is a <strong> correct </strong> answer
                          </div>
                        </div>
                        :
                        null
                      }
                      { node.answer && node.correct == 'incorrect' ?
                        <div className="yt-row">
                          <div className="-icon"><i className="far fa-thumbs-down"/> </div>
                          <div className="yt-col">
                            This is an <strong> incorrect </strong> answer
                          </div>
                        </div>
                        :
                        null
                      }
                      { node.answer && node.correct == 'survey' ?
                        <div className="yt-row">
                          <div className="-icon"><i className="far fa-clipboard-list"/> </div>
                          <div className="yt-col">
                            This is a <strong> survey </strong> answer
                          </div>
                        </div>
                        :
                        null
                      }
                      { node.checkpoint ?
                        <div className="yt-row">
                          <div className="-icon"><i className="fas fa-check"/> </div>
                          <div className="yt-col">
                            This is a checkpoint
                          </div>
                        </div>
                        :
                        null
                      }
                      { node.topicChange ?
                        <div className="yt-row">
                          <div className="-icon"><i className="fas fa-exchange"/> </div>
                          <div className="yt-col">
                            This is the start of a major topic change
                          </div>
                        </div>
                        :
                        null
                      }
                      { node.exit ?
                        <div className="yt-row">
                          <div className="-icon"><i className="fas fa-sign-out"/> </div>
                          <div className="yt-col">
                            User can exit the module from here
                          </div>
                        </div>
                        :
                        null
                      }
                      <hr/>
                      <p><strong>Notes:</strong></p>
                      <p> {node.notes} </p>
                      <button className="yt-btn small block info" onClick={() => this.props.handleOpenModal('editNode')}>Edit node</button>
                    </div>
                  }
                </div>
              </div>
              :
              null
            }
          </div>
        </Draggable>
      </div>
    );
  }
}

GraphNode.propTypes = {
  handleOpenModal: PropTypes.func.isRequired
  , metrics: PropTypes.array
  , node: PropTypes.object.isRequired
  , onDrag: PropTypes.func.isRequired
  , onDragEnd: PropTypes.func.isRequired
  , onDragStart: PropTypes.func.isRequired
  , onSelect: PropTypes.func.isRequired
  , onDeselect: PropTypes.func.isRequired
  , onStartTransition: PropTypes.func.isRequired
  , scale: PropTypes.number
  , scene: PropTypes.object
  , selected: PropTypes.bool
  , selectedScene: PropTypes.object
  , selectedContentModuleId: PropTypes.string
}

GraphNode.defaultProps = {
  metrics: []
  , scale: 1
  , scene: {}
  , selected: false
  , selectedScene: null
}

export default GraphNode;



// WEBPACK FOOTER //
// modules/node/components/GraphNode.js.jsx